import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IMoreSupportProps } from '../types';
import { MoreSupport } from '../MoreSupport';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IMoreSupportProps = elementAttributesToProps(domNode);

  return Promise.resolve(<MoreSupport {...props} />);
};

export default rehydrator;
